const OPEN_DELETE_BRANCH_WIZARD = 'OPEN_DELETE_BRANCH_WIZARD';
const CLOSE_DELETE_BRANCH_WIZARD = 'CLOSE_DELETE_BRANCH_WIZARD';

export { OPEN_DELETE_BRANCH_WIZARD, CLOSE_DELETE_BRANCH_WIZARD };
